export const data: any = {
  NEXT_PUBLIC_BASE_URL: "https://developer.trimble.com",
  NEXT_PUBLIC_SITEMAP_BASE_URL: "https://developer.trimble.com",
  NEXT_PUBLIC_SITE_MACHINE_NAME: "trimble-developer",
  NEXT_PUBLIC_CF_MXP_SPACE_ID: "citn2sn5tdjr",
  NEXT_PUBLIC_GTM_ID: "GTM-TPFGGLT",
  NEXT_PUBLIC_ONETRUST_ID: "fce01d48-d474-4578-90a5-f2ba5be6ae6a",
}
